export default "__VITE_ASSET__02raGGjw__"